import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"
import userReducers from "../reducers"

const updateUserDataAndSaveTokens = (state, action) => {
  userReducers.setData(state, action)
  userReducers.setTokens(state, action)
}

/* Trade Google's ID token for ours.

   The credential is the only thing that crosses: the backend verifies it against Google and answers
   with the same `{refresh, access}` pair `/token/` returns, so from here on this session is
   indistinguishable from a password login — same interceptor, same refresh, same `?access=` on the
   WebSocket. Nothing downstream needs to know which button was pressed.

   Registration happens here too, server-side, on a first sign-in. There is no second call. */
export const thunk = createAsyncThunk("user/googleLogin", async (credential, { rejectWithValue }) => {
  try {
    const response = await apiClient.post("/auth/google/", { credential })
    return {
      refreshToken: response.data.refresh,
      accessToken: response.data.access,
    }
  } catch (error) {
    // A network failure has no `response`, and reading `.data` off it would replace the server's
    // refusal with a TypeError the player cannot act on.
    return rejectWithValue(error.response?.data || { detail: "Could not reach the server." })
  }
})

export const onSucceed = updateUserDataAndSaveTokens

const thunkObject = { thunk, onSucceed }
export default thunkObject
